import React, { forwardRef } from "react"

import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
export default forwardRef((props) =>
    <SignalCellularAltIcon {...props} style={{ widht: "16px", color: "#b0b2bc" }} />
)

